module.exports = __webpack_public_path__ + "static/media/e-remove.1d2a6e09.svg";